import { Action, State, StateContext, Store } from '@ngxs/store';
import { ScholarshipType, ScholarshipTypeMap } from '../../models/scholarship-type.model';
import { Injectable } from '@angular/core';
import { AlertService } from '../../../../shared/store/alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { ScholarshipTypeActions } from './scholarship-type.actions';
import { ScholarshipService } from '../../service/scholarship.service';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';

export class ScholarshipTypeStateModel {
  public scholarshipTypes: ScholarshipType[];
  public scholarshipTypesMap: ScholarshipTypeMap[];
  public error: string;
}

const defaults = {
  scholarshipTypes: [],
  scholarshipTypesMap: [],
  error: '',
};

@State<ScholarshipTypeStateModel>({
  name: 'scholarshipType',
  defaults,
})
@Injectable()
export class ScholarshipTypeState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private scholarshipService: ScholarshipService,
    public store: Store
  ) {}

  @Action(ScholarshipTypeActions.GetScholarships)
  getScholarships(
    ctx: StateContext<ScholarshipTypeStateModel>,
    { zoneId }: ScholarshipTypeActions.GetScholarships
  ) {
    return this.scholarshipService.getScholarships(zoneId).subscribe({
      next: (response) =>
        ctx.dispatch(
          new ScholarshipTypeActions.GetScholarshipsSuccess(response)
        ),
      error: (error) =>
        ctx.dispatch(new ScholarshipTypeActions.GetScholarshipsFail(error)),
    });
  }

  @Action(ScholarshipTypeActions.GetScholarshipsSuccess)
  getScholarshipsSuccess(
    ctx: StateContext<ScholarshipTypeStateModel>,
    { scholarshipTypes }: ScholarshipTypeActions.GetScholarshipsSuccess
  ) {
    ctx.patchState({
      scholarshipTypes: scholarshipTypes.sort((a, b) => a.description.localeCompare(b.description))
    });
  }

  @Action(ScholarshipTypeActions.GetScholarshipsFail)
  getScholarshipsFail(
    ctx: StateContext<ScholarshipTypeStateModel>,
    { error }: ScholarshipTypeActions.GetScholarshipsFail
  ) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  @Action(ScholarshipTypeActions.GetScholarshipTypes) getScholarshipTypes(
    ctx: StateContext<ScholarshipTypeStateModel>,
    {  }: ScholarshipTypeActions.GetScholarshipTypes
  ) {
    return this.scholarshipService.getScholarshipTypes().subscribe({
      next: (response) =>
        ctx.dispatch(
          new ScholarshipTypeActions.GetScholarshipTypesSuccess(response)
        ),
      error: (error) =>
        ctx.dispatch(new ScholarshipTypeActions.GetScholarshipTypesFail(error)),
    });
  }

  @Action(ScholarshipTypeActions.GetScholarshipTypesSuccess)
  getScholarshipTypesSuccess(
    ctx: StateContext<ScholarshipTypeStateModel>,
    { scholarshipTypesMap }: ScholarshipTypeActions.GetScholarshipTypesSuccess
  ) {
    ctx.patchState({
      scholarshipTypesMap: scholarshipTypesMap.sort((a, b) => a.scholarshipTypeName.localeCompare(b.scholarshipTypeName))
    });
  }

  @Action(ScholarshipTypeActions.GetScholarshipTypesFail)
  getScholarshipTypesFail(
    ctx: StateContext<ScholarshipTypeStateModel>,
    { error }: ScholarshipTypeActions.GetScholarshipTypesFail
  ) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('labels.scholarshipType');
  }
}
